export default __webpack_public_path__ + "static/media/screenshot.09dd571b.svg";